var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherIncome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.334 8.5C20.4761 8.5 23.834 11.8579 23.834 16C23.834 20.1421 20.4761 23.5 16.334 23.5C12.1918 23.5 8.83398 20.1421 8.83398 16C8.83398 11.8579 12.1918 8.5 16.334 8.5ZM16.334 11.125C15.9198 11.125 15.584 11.4608 15.584 11.875V12.3809C14.7106 12.69 14.084 13.5207 14.084 14.5C14.084 15.7165 15.0495 16.7039 16.2559 16.7451L16.2568 16.7461L16.4111 16.7539C16.7891 16.7925 17.084 17.1118 17.084 17.5C17.084 17.9142 16.7482 18.25 16.334 18.25C15.9458 18.25 15.6265 17.9551 15.5879 17.5771L15.5801 17.4229C15.5415 17.0449 15.2222 16.75 14.834 16.75C14.4198 16.75 14.084 17.0858 14.084 17.5C14.084 18.4792 14.7107 19.3089 15.584 19.6182V20.125C15.584 20.5392 15.9198 20.875 16.334 20.875C16.7482 20.875 17.084 20.5392 17.084 20.125V19.6182C17.9573 19.3089 18.584 18.4792 18.584 17.5C18.584 16.2574 17.5766 15.25 16.334 15.25L16.2568 15.2461C15.8789 15.2075 15.584 14.8882 15.584 14.5C15.584 14.0858 15.9198 13.75 16.334 13.75C16.7222 13.75 17.0415 14.0449 17.0801 14.4229L17.0879 14.5771C17.1265 14.9551 17.4458 15.25 17.834 15.25C18.2482 15.25 18.584 14.9142 18.584 14.5C18.584 13.5207 17.9574 12.69 17.084 12.3809V11.875C17.084 11.4608 16.7482 11.125 16.334 11.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherIncome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/other_income.6dcbb6e129c9dd4dd70a0c11eae6ada6.svg";